import type { Predicate } from 'fp-ts/lib/function';

export const somePass =
  <T>(predicates: Predicate<T>[]) =>
  (value: T): boolean =>
    predicates.some((predicate) => predicate(value));

export const everyPass =
  <T>(predicates: Predicate<T>[]) =>
  (value: T): boolean =>
    predicates.every((predicate) => predicate(value));
